import { getLang, trField, urlHelper } from "helpers/themeHelpers";

export const linkMobileTabletPrices = (part2, { brand }) => {
  const locale = getLang();
  const part1 =
    locale === "ar"
      ? `اسعار-مواصفات-موبايلات-تابلت`
      : `mobile-tablet-prices-specs`;
  const parts = [locale, part1, part2, urlHelper(brand)].filter(Boolean);
  return "/" + parts.join("/");
};

export const linkMobileTabletPricesWithSlug = (slugs, obj) => {
  const slug = Object.values(slugs)
    .map((it) => it)
    .filter(Boolean)
    .join("/");
  const locale = getLang();

  return `/${locale}/${
    locale === "ar"
      ? `اسعار-مواصفات-موبايلات-تابلت`
      : `mobile-tablet-prices-specs`
  }/${slug}/${urlHelper(obj)}`;
};

export const linkBuilderMobileTabletOtherModel = (slugs, obj, key) => {
  const slug = Object.values(slugs)
    .map((it) => it)
    .filter(Boolean)
    .join("/");
  const locale = getLang();

  return `/${locale}/${
    locale === "ar"
      ? `اسعار-مواصفات-موبايلات-تابلت`
      : `mobile-tablet-prices-specs`
  }/${slug}/${trField(obj, key)}`;
};
